const cooperationManage = {
  appCode: {
    development: '1285048512307871745',
    fat: '1285048512307871745',
    test: '1285048512307871745',
    production: '1285048512307871745'
  }[process.env.VUE_APP_ENV_NAME],
  clientId: {
    development: 'app_7ab8c333',
    fat: 'app_7ab8c333',
    test: 'app_7ab8c333',
    production: 'app_7ab8c333'
  }[process.env.VUE_APP_ENV_NAME],
  js: './cooperation-manage/main.js'
};

export default cooperationManage;
